import React, { Component } from 'react'
import { Collapse } from 'antd'
const { Panel } = Collapse
import ShabanCost from './ShabanCost'
import Preset from './Preset'

export default class extends Component {
    render() {
        return (
            <Collapse style={{ flexDirection: 'column' }} accordion>
                <Panel header="שב''ן">
                    <ShabanCost />
                </Panel>
                <Panel header="סיעודי">
                    <Preset />
                </Panel>
            </Collapse>
        )
    }
}
